import { render, staticRenderFns } from "./ReparationsAmount.vue?vue&type=template&id=a05c11d0&scoped=true"
import script from "./ReparationsAmount.vue?vue&type=script&lang=js"
export * from "./ReparationsAmount.vue?vue&type=script&lang=js"
import style0 from "./ReparationsAmount.vue?vue&type=style&index=0&id=a05c11d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05c11d0",
  null
  
)

export default component.exports